<template>
    <div>
        <b-button
                :disabled="paymentProcessing"
                v-if="!customFlow"
                id="checkout-button"
                variant="primary"
                block class="mt-2"
                @click="checkoutOrder">Checkout {{payableAmount | currency}}</b-button>
        <div  v-if="customFlow" id="payment-form">
            <div id="card-element"><!--Stripe.js injects the Card Element--></div>
            <b-button
                    :disabled="!(getClientSecret && card && !paymentProcessing)"
                    id="submit"
                    variant="primary"
                    block class="mt-2"
                    @click="confirmCardPayment()">Pay {{payableAmount | currency}}</b-button>
            <div id="payment-request-button" class="mt-2"><!-- A Stripe Element will be inserted here. --></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "paymentFormStripe",
        data(){
            return { stripe : null, card : null, paymentProcessing : false, paymentRequest : null, customFlow : false }
        },
        props : {
            payableAmount:{type:Number},
        },
        mounted() {
            this.$nextTick(()=>{
                //eslint-disable-next-line
                this.stripe = Stripe(this.getState.stripe.publishKey, { stripeAccount : this.getState.stripe.stripeAccount });
                this.stripeMountInit();
                this.paymentIntent();
            })
        },
        computed: {
            getState(){
                return this.$store.getters.getState;
            },
            getClientSecret(){
                return this.getState.stripeClientSecret || null;
            },
            orderPendingId(){
                return this.getState.orderPendingId
            }
        },
        watch : {
            payableAmount() {
                if(this.paymentRequest) {
                    this.paymentRequest.update({ total : { label: 'Total', amount: Math.floor(this.payableAmount * 100) } });//Update Amount
                }
            }
        },
        methods: {
            stripeMountInit() {
                if(!this.customFlow){
                    return
                }
                var elements = this.stripe.elements();
                {
                    var style = {
                        base: {
                            color: "#32325d",
                            fontFamily: 'Arial, sans-serif',
                            fontSmoothing: "antialiased",
                            fontSize: "16px",
                            "::placeholder": { color: "#32325d" }
                        },
                        invalid: {
                            fontFamily: 'Arial, sans-serif',
                            color: "#fa755a",
                            iconColor: "#fa755a"
                        }
                    };
                    this.card = elements.create("card", { style: style });
                    // Stripe injects an iframe into the DOM
                    this.card.mount("#card-element");
                }
                {
                    this.paymentRequest = this.stripe.paymentRequest({
                        country: 'US',
                        currency: 'usd',
                        total: {
                            label: 'Demo total',
                            amount: Math.floor(this.payableAmount * 100),
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                    });
                    var prButton = elements.create('paymentRequestButton', { paymentRequest : this.paymentRequest });
                    this.paymentRequest.canMakePayment().then(function(result) {
                        console.log("PaymentRequest", result)
                        //this.paymentRequest.show();
                        if (result) {
                            console.log("prButton", result)
                            prButton.mount('#payment-request-button');//Todo Replace Google Button
                        } else {
                            document.getElementById('payment-request-button').style.display = 'none';
                        }
                    });
                    this.paymentRequest.on('paymentmethod', (ev) => {
                        this.paymentProcessing = true;
                        this.paymentIntent(() => {
                            if(this.getClientSecret && this.card) {
                                this.stripe
                                    .confirmCardPayment(this.getClientSecret, { payment_method: ev.paymentMethod.id }, {handleActions: false})
                                    .then(result => {
                                        if(result.paymentIntent) {
                                            this.$emit("on-submit", this.orderPendingId)
                                        } else {
                                            this.paymentProcessing = false;
                                            // this.$store.dispatch('setPendingOrder', { stripeClientSecret:null , orderPendingId:this.orderPendingId});
                                            console.error("Payment Error", result.error)
                                        }
                                    })
                                    .catch(error => {
                                        this.paymentProcessing = false;
                                        console.log(error)
                                    });
                            }else{
                                this.paymentProcessing = false;
                                console.log("Not Ready")//Todo Require Some Method
                            }
                        });
                    });
                }
            },
            paymentIntent(callback) {
                if(!this.customFlow){
                    return
                }
                if(this.getClientSecret) {
                    //update payment intent
                    this.$store.dispatch('setOrderUpdate')
                        .then(({status, data, error})=>{
                            if(status){
                                this.$store.dispatch('setPendingOrder', data);
                                if(callback){
                                    callback();
                                }
                            }else{
                                console.error("paymentIntent", error)
                            }
                        })
                        .catch(error => console.error("paymentIntent", error))
                } else {
                    //fetch new payment intent
                    this.$store.dispatch('setOrderPrepare')
                        .then(({status, data, error})=>{
                            if(status) {
                                this.$store.dispatch('setPendingOrder', data);
                            } else {
                                console.error("paymentIntent", error)
                            }
                        })
                        .catch(error => console.error("paymentIntent", error))
                }
            },
            confirmCardPayment() {
                this.paymentProcessing = true;
                this.paymentIntent(() => {
                    if(this.getClientSecret && this.card) {
                        this.stripe
                            .confirmCardPayment(this.getClientSecret, { payment_method: {  card: this.card  } })
                            .then(result => {
                                if(result.paymentIntent) {
                                    this.$emit("on-submit", this.orderPendingId)
                                } else {
                                    this.paymentProcessing = false;
                                    // this.$store.dispatch('setPendingOrder', { stripeClientSecret:null , orderPendingId:this.orderPendingId});
                                    console.error("Payment Error", result.error)
                                }
                            })
                            .catch(error => {
                                this.paymentProcessing = false;
                                console.log(error)
                            });
                    }else{
                        this.paymentProcessing = false;
                        console.log("Not Ready")//Todo Require Some Method
                    }
                });
            },

            checkoutOrder() {
                //fetch new payment intent
                this.paymentProcessing = true;
                this.$store.dispatch('setOrderChekout')
                    .then(({status, data, error})=>{
                        if(status) {
                            this.stripe.redirectToCheckout({ sessionId: data.sessionId });
                        } else {
                            console.error("paymentIntent", error)
                        }
                        this.paymentProcessing = false;
                    })
                    .catch(error => { 
                        this.paymentProcessing = false; 
                        console.error("paymentIntent", error);
                    })
            }
        }
    }
</script>
<style lang="scss" scoped>
    /* Variables */
    * {
        box-sizing: border-box;
    }
    body {
        font-family: -apple-system, BlinkMacSystemFont, sans-serif;
        font-size: 16px;
        -webkit-font-smoothing: antialiased;
        display: flex;
        justify-content: center;
        align-content: center;
        height: 100vh;
        width: 100vw;
    }
    form {
        align-self: center;
        // box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1), 0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
        // border-radius: 7px;
        // padding: 40px;
    }
    input {
        border-radius: 6px;
        margin-bottom: 6px;
        padding: 12px;
        border: 1px solid rgba(50, 50, 93, 0.1);
        height: 44px;
        font-size: 16px;
        width: 100%;
        background: white;
    }
    .result-message {
        line-height: 22px;
        font-size: 16px;
    }
    .result-message a {
        color: rgb(89, 111, 214);
        font-weight: 600;
        text-decoration: none;
    }
    .hidden {
        display: none;
    }
    #card-error {
        color: rgb(105, 115, 134);
        text-align: left;
        font-size: 13px;
        line-height: 17px;
        margin-top: 12px;
    }
    #card-element {
        border-radius: 4px 4px 0 0 ;
        padding: 12px;
        border: 1px solid rgba(50, 50, 93, 0.1);
        height: 44px;
        width: 100%;
        background: white;
    }
    #payment-request-button {
        margin-bottom: 32px;
    }
    /* Buttons and links */
    // button {
    //     background: #5469d4;
    //     color: #ffffff;
    //     font-family: Arial, sans-serif;
    //     border-radius: 0 0 4px 4px;
    //     border: 0;
    //     padding: 12px 16px;
    //     font-size: 16px;
    //     font-weight: 600;
    //     cursor: pointer;
    //     display: block;
    //     transition: all 0.2s ease;
    //     box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    //     width: 100%;
    // }
    // button:hover {
    //     filter: contrast(115%);
    // }
    // button:disabled {
    //     opacity: 0.5;
    //     cursor: default;
    // }
    /* spinner/processing state, errors */
    .spinner,
    .spinner:before,
    .spinner:after {
        border-radius: 50%;
    }
    .spinner {
        color: #ffffff;
        font-size: 22px;
        text-indent: -99999px;
        margin: 0px auto;
        position: relative;
        width: 20px;
        height: 20px;
        box-shadow: inset 0 0 0 2px;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
    }
    .spinner:before,
    .spinner:after {
        position: absolute;
        content: "";
    }
    .spinner:before {
        width: 10.4px;
        height: 20.4px;
        background: #5469d4;
        border-radius: 20.4px 0 0 20.4px;
        top: -0.2px;
        left: -0.2px;
        -webkit-transform-origin: 10.4px 10.2px;
        transform-origin: 10.4px 10.2px;
        -webkit-animation: loading 2s infinite ease 1.5s;
        animation: loading 2s infinite ease 1.5s;
    }
    .spinner:after {
        width: 10.4px;
        height: 10.2px;
        background: #5469d4;
        border-radius: 0 10.2px 10.2px 0;
        top: -0.1px;
        left: 10.2px;
        -webkit-transform-origin: 0px 10.2px;
        transform-origin: 0px 10.2px;
        -webkit-animation: loading 2s infinite ease;
        animation: loading 2s infinite ease;
    }
    @-webkit-keyframes loading {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes loading {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @media only screen and (max-width: 600px) {
        form {
            width: 80vw;
        }
    }
</style>